import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { BreadcrumbProps } from 'antd';
import { useSetAtom } from 'jotai';
import { headerBreadcrumbsAtom } from '~/stores/BreadcrumbStore';

const UI_Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

const UI_Content_Wrapper = styled.div`
  padding: 16px;
  overflow-y: auto;
  flex-grow: 1;

  @media (max-width: 768px) {
    padding: 12px;
  }

  @media (max-width: 480px) {
    padding: 8px;
  }
`;

const UI_Title = styled.div`
  font-size: 18px;
  padding: 24px;
  background-color: #fff;

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 16px 12px;
  }

  @media (max-width: 480px) {
    font-size: 15px;
    padding: 12px 8px;
  }
`;

/**
 * UI_Breadcrumb: Replaced 70px in-page breadcrumb bar with null render.
 * Breadcrumb items are dispatched to headerBreadcrumbsAtom for display in AppHeader.
 */
const UI_Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const setHeaderBreadcrumb = useSetAtom(headerBreadcrumbsAtom);
  const prevItemsRef = useRef<BreadcrumbProps['items']>();

  useEffect(() => {
    if (items && items.length > 0) {
      prevItemsRef.current = items;
      setHeaderBreadcrumb(items);
    }
    return () => {
      setHeaderBreadcrumb((current) => (current === prevItemsRef.current ? null : current));
    };
  }, [items, setHeaderBreadcrumb]);

  return null;
};

export const UI_ScreenStyles = {
  UI_Wrapper,
  UI_Content_Wrapper,
  UI_Title,
  UI_Breadcrumb,
};

